/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _errorTile = _interopRequireDefault(require("./errorTile.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * A tile to show if data fetching failed for a coordinate in the
 * Program Guide grid.
 *
 * Shows an error label with given information about
 * the error that has occurred and a button for triggering
 * a retry of the failed data request.
 *
 * @param {object} props See propTypes
 * @returns {ErrorTile} A ErrorTile component
 */
var ErrorTile = function ErrorTile(_ref) {
  var width = _ref.width,
    height = _ref.height,
    error = _ref.error,
    onReload = _ref.onReload,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'Retry' : _ref$buttonText,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _errorTile["default"] : _ref$theme;
  var _style = _objectSpread({
    width: width,
    height: height
  }, style);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.errorTile,
    style: _style
  }, error ? /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.text
  }, error) : '', /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onReload
  }, buttonText));
};
ErrorTile.propTypes = {
  /** Text to be displayed in the middle of the tile */
  buttonText: _propTypes["default"].string,
  /** Error text to be displayed */
  error: _propTypes["default"].string,
  /** Height of the tile */
  height: _propTypes["default"].number,
  /** Handler for triggering a reload of data. */
  onReload: _propTypes["default"].func,
  /** Style object to be applied to the outer container div */
  style: _propTypes["default"].object,
  /** Classname API for theming */
  theme: _propTypes["default"].shape({
    errorTile: _propTypes["default"].string,
    text: _propTypes["default"].string
  }),
  /** Width of the tile */
  width: _propTypes["default"].number
};
var _default = /*#__PURE__*/_react["default"].memo(ErrorTile);
exports["default"] = _default;